import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, IBorderRefusal } from '../../../../../types';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';

function VisaPrepAdditionalHistoryStep6Info(props: IVisaPrepForm) {
  const renderBorderRefusals = () => {
    const allBorderRefusals: React.ReactNode[] = [];
    if (props.borderRefusals && props.borderRefusals.length) {
      props.borderRefusals.forEach((borderRefusal: IBorderRefusal, i: number) => {
        allBorderRefusals.push(
          <SummaryGroup title={`Border refusal ${i + 1}`} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.BORDER_REFUSAL_DATE}-${i}`}
              label="Date of refusal"
              value={borderRefusal.refusalDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.BORDER_REFUSAL_AIRPORT}-${i}`}
              value={borderRefusal.airport}
              label="Port or airport"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.BORDER_REFUSAL_REASON}-${i}`}
              value={borderRefusal.reason}
              label="Reason"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.BORDER_REFUSAL_REFERENCE}-${i}`}
              value={borderRefusal.reference}
              label="Reference number"
            />
          </SummaryGroup>,
        );
      });
    }
    return allBorderRefusals;
  };
  return (
    <>
      <SummaryRow className={'visa-summary'} label="Number of border refusals" value={props.borderRefusals?.length} />

      <Box as="ol" pl={8} key={'border-refusals'}>
        {renderBorderRefusals()}
      </Box>
    </>
  );
}

export default VisaPrepAdditionalHistoryStep6Info;
